import { requestWithToken } from '../utilities/request';
const path = '/api/private/login_user_groups';

const list = params => {
  return requestWithToken({
    method: 'GET',
    url: path,
    params,
  });
};

const checkIntegrate = params => {
  return requestWithToken({
    method: 'GET',
    url: `${path}/integrate_check`,
    params,
  });
};

const checkDuplicateEmail = params => {
  return requestWithToken({
    method: 'GET',
    url: `${path}/duplicate_email_check`,
    params,
  });
};

const updateUser = data => {
  return requestWithToken({
    method: 'POST',
    url: `${path}/update_user`,
    data,
  });
};

export const LoginUserGroupsService = {
  list,
  checkIntegrate,
  checkDuplicateEmail,
  updateUser,
};



// WEBPACK FOOTER //
// ./src/services/LoginUserGroups.js